import { generateColor } from 'utils';
import i18next from 'i18next';

const OTHER_COLOR = '#F04632';

const transformToPastByTrainingModules = (data = [], otherPosition) => {
  const usedColors = new Set([OTHER_COLOR]);
  const statData = data.map(item => ({
    value: item.count,
    label: item.name,
    legendTitle: item.name,
    filterValue: item.trainingModuleId || item.id || item.name,
    fillColor: generateColor(item.name, usedColors),
  }));

  statData.sort((a, b) => b.value - a.value);

  if (statData.length > otherPosition) {
    let otherValue = 0;
    const modulesSorted = statData.map((item, index) => {
      if (index > otherPosition - 2) {
        otherValue += item.value;
        return {
          ...item,
          hideLabel: true,
          hiddenInData: true,
        };
      }
      return item;
    });

    return [
      ...modulesSorted,
      {
        value: otherValue,
        legendTitle: i18next.t('legend.other'),
        fillColor: OTHER_COLOR,
        hideLabel: false,
        withExtInfo: true,
      },
    ];
  }

  return statData;
};

export default transformToPastByTrainingModules;
